<template>
<!--内容列表-->
  <div id="contenList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
<!--            <span>ID</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" placeholder="ID" type="number" v-model="postData.ID"> -->
            <input @keyup.enter="getList(1)" class="allInput m_r_10" placeholder="ID" type="text" v-model="postData.ID" oninput="value=value.replace(/[^\d]/g,'')">
            <input @keyup.enter="getList(1)" class="allInput" placeholder="标题" type="text" v-model="postData.title">
          </p>
          <p>
<!--            <span>名称</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" placeholder="名称" type="text" v-model="postData.title"> -->
            <input @keyup.enter="getList(1)" class="allInput" placeholder="标签" type="text" v-model="postData.tags">
          </p>
<!--          <p>-->
<!--            <input @keyup.enter="getList(1)" class="allInput" placeholder="tag" type="text" v-model="postData.tag">-->
<!--          </p>-->
          <p>
<!--            <span>内容分类</span>-->
            <abbr class="d_i">
              <allSelect :chooseData="searchCate" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{productName}} | {{name}}'" v-model="postData.categoryId">
              </allSelect>
            </abbr>
          </p>
<!--          <p v-if="onSearch"><span>创建人</span>-->
<!--            <input class="allInput" type="text" v-model="postData.name">-->
<!--          </p>-->
          <!-- <p v-if="onSearch"> -->
<!--            <span class="d_i">更新时间</span>-->
            <!-- <cander v-model="postData.startdate" :className="'allInput'" placeholderName="更新开始时间"  class="d_i" style="vertical-align: middle"></cander>
            <abbr class="d_i">-</abbr>
            <cander :minDate="postData.startdate" v-model="postData.enddate" :className="'allInput'" placeholderName="更新结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p> -->
          <button @click="getList(1)" class="redButton">搜索</button>
        </div>
        <div style="width: auto">
          <!-- <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span> -->
          <!-- <button @click="clearModel()" class="cancelButtonTwo m_r_10">清空</button> -->
<!--          <button class="redButtonTwo" @click="editToUrl()" >新建</button>-->
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <!-- <nav class="t_r m_b_10"><button class="redButtonTwo" @click="editToUrl()" v-if="nowApp.roles.indexOf('ContentEditor') >= 0">新建</button></nav> -->
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th>序号</th>
            <th>ID</th>
            <th>标题</th>
            <th>文章类型</th>
            <th>分类</th>
            <th>标签</th>
            <th>更新时间</th>
            <th class="t_c">创建人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td width="7%">{{totalCount - ((index + 1) + (10 * (postData.PageIndex - 1))) + 1}}</td>
            <td width="7%">{{item.id}}</td>
            <td width="16%" class="NoWrap" style="max-width: 250px" :title="item.title">{{item.title}}</td>
            <td width="10%">{{item.articleType == 'F' ? '武田推文' : '腾讯推文'}}</td>
            <td width="10%">{{item.categoryName}}</td>
            <td width="14%" :title="item.tags" class="NoWrap" style="max-width: 250px">{{item.tags}}</td>
            <td width="15%">{{item.lastModificationTime ? $commonJs.returnNewDate(item.lastModificationTime) : ''}}</td>
            <td width="10%" :title="item.createUserName" style="max-width: 100px" class="t_c NoWrap">{{item.createName}}</td>
            <td width="11%"><div class="icon more iconfont icongengduo moreOperations">
              <ul>
                <li @click="viewList(item)">查看</li>
                <li @click="copyUrl(index)"><input style="position: fixed;top: -9999px" :id="'copyInpue' + index" :value="returnUrl(item)" type="text">复制链接</li>
                <!-- <li  @click="unShelve(item)" v-if="item.creatorId == userInfo.id && item.isinactive === null">下架</li> -->
                <li v-if="item.creatorId == userInfo.id" @click="returnArticle(item)">退回</li>
                <li v-if="$childMenu.indexOf('修改创建人') >= 0" @click="EditCreateuser(item)">修改创建人</li>
                <!-- <li @click="deleteDraft(item)" >删除</li> -->
              </ul>
            </div></td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!--内容列表-新建内容-->
    <contentPreview :forType="'contentReadAll'" :doctorOpenId="doctorOpenId" :contentId="previewContentId" v-model="coverShow"></contentPreview>
    <!--add by fengwu.yang 2025/03/14 吾医达前端文章页面优化 start-->
    <model v-if="dominUserModel" :buttonType="0" :title="'修改创建人'" :minWidth="'600px'" v-on:on-cancel="canceluserModel()" v-on:on-confirm="confiruserModel()" :showAuto="true">
      <div style="padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px;width: auto">选择用户</span>
            <div style="display: inline-block;vertical-align: middle;width: calc(100% - 80px)" class="m_l_10 p_r">
              <input type="text" class="allInput" placeholder="请输入姓名/邮箱搜索" style="width: calc(100% - 12px)" @input="searchUser" v-model="sechUser">
              <div class="p_a assSerch" style="top: 30px;left: 0px;z-index: 10" v-if="isUser">
                <p v-if="myUserList.length > 0" :key="index" v-for="(item, index) in myUserList" class="userList" @click="onSerUser(item)">{{ item.chineseName }} - {{item.email}}</p>
                <p v-if="myUserList.length === 0">暂无数据</p>
              </div>
            </div>
          </li>
          <li>
            <span style="font-size:16px;width: auto">原创建人</span>
            <div style="display: inline-block;vertical-align: middle;width: calc(100% - 80px)" class="m_l_10">
              <input maxlength="50" v-model="CreateUse" type="text" class="allInput" style="width: calc(100% - 12px);" disabled/>
            </div>
          </li>
          <li>
            <span style="font-size:16px;width: auto">文章title</span>
            <div style="display: inline-block;vertical-align: middle;width: calc(100% - 80px)" class="m_l_10">
            <input maxlength="50" v-model="ArticleName" type="text" class="allInput" style="width: calc(100% - 12px);" disabled/>
            </div>
          </li>
        </ul>
      </div>
    </model>
    <!--add by fengwu.yang 2025/03/14 吾医达前端文章页面优化 end-->
  </div>
</template>

<script>
import contentPreview from '../../myComponents/contentPreview'
let allTimeOut
export default {
  name: 'contenList',
  data () {
    return {
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      previewContentId: 0,
      doctorOpenId: '',
      addnewContentType: '',
      dominUserModel: false,
      sechUser: '',
      isUser: false,
      myUserList: [],
      userData: {
        userName: '',
        userId: '',
        email: ''
      },
      CreateUse: '',
      ArticleID: '',
      ArticleName: '',
      onSearch: false,
      coverShow: false,
      newModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        ID: '',
        title: '',
        status: 2,
        ContentTypeIds: '',
        categoryId: '',
        startdate: '',
        tags: '',
        enddate: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      allcontent: JSON.parse(window.sessionStorage.getItem('allContentType')),
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')) || [{id: 1, typeName: '测试类别'}],
      searchCate: [{
        id: '',
        name: '全部',
        productName: '全部'
      }]
    }
  },
  created () {
    console.log(this.userInfo, 'userInfo')
    this.searchCate = this.searchCate.concat(this.allcontent2)
    // this.getconTypeList()
    // this.getconTypeList2()
    this.getList(1)
  },
  methods: {
    unShelve(item){
      this.$axiox.get(`/api/Article/recall?articleId=${item.id}`).then( p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '下架成功',
          stayTime: 5
        })
        this.getList(1)
      } )
    },
    returnUrl (item) {
      return 'https://' + window.location.host + '/mobileContent?id=' + item.id + `&source=WY`
    },
    copyUrl (index) {
      let Url2 = document.getElementById('copyInpue' + index)
      Url2.select() // 选择对象
      document.execCommand('Copy')
    },
    clearModel () {
      this.postData = {
        ID: '',
        title: '',
        status: 2,
        ContentTypeIds: '',
        startdate: '',
        enddate: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      }
    },
    // getconTypeList () {
    //   this.$axiox.get('/api/contentType/fromuser/' + JSON.parse(this.userInfo.id)).then(msg => {
    //     let editorTypes = JSON.parse(JSON.stringify(msg.result.editorTypes))
    //     let ownerTypes = JSON.parse(JSON.stringify(msg.result.ownerTypes))
    //     this.allcontent2 = this.$commonJs.distinct(editorTypes, ownerTypes)
    //     console.log(this.allcontent2)
    //   })
    // },
    // getconTypeList2 () {
    //   let url = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
    //   this.$axiox.get(url).then(msg => {
    //     this.allcontent = JSON.parse(JSON.stringify(msg.result.items))
    //   })
    // },
    deleteDraft (object) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此草稿？',
        successFun: msg => {
          this.$axiox.del('/api/Article/' + object.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    viewList (object) {
      console.log(object)
      this.previewContentId = object.id
      this.doctorOpenId = object.openId
      this.coverShow = true
    },
    cencelPreview () {
      this.coverShow = false
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl () {
      this.newModel = true
      // this.$router.push({
      //   path: 'editContList',
      //   query:{id: 0}
      // })
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.startdate === '') {
        delete data['startdate']
      }
      if (data.enddate === '') {
        delete data['enddate']
      }
      let url = this.$commonJs.returnQuery('/api/Article', data)
      this.$axiox.getList(url).then(msg => {
        console.log(msg)
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
      console.log(this.postData)
    },
    editList (item) {
      this.$router.push({
        name: 'editContList',
        query: {
          id: item.id,
          fromType: 'draft',
          selectContentType: 0,
          selectContentName: item.contentType
        }
      })
    },
    confirModel () {
      if (this.addnewContentType !== '') {
        let selectContentName = this.allcontent2.find(p => { return parseInt(p.id) === parseInt(this.addnewContentType) })
        this.$router.push({
          name: 'editContList',
          query: {
            id: 0,
            fromType: 'draft',
            selectContentType: this.addnewContentType,
            selectContentName: selectContentName.name
          }
        })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择内容类别!',
          stayTime: 5
        })
      }
    },
    cancelModel () {
      this.addnewContentType = ''
      this.newModel = false
    },
    returnArticle (item) {
      this.$axiox.get(`/api/Article/ReturnArticle/${item.id}`).then(res => {
        console.log(res, 'returnArticle')
        if (res) {
          this.getList(1)
        }
      })
    },
    confiruserModel () {
    if (this.userData.userId === '') {
      this.$commonJs.alertTips({
        type: 'error',
        title: '错误',
        content: '请选择用户',
        stayTime: 5
      })
      return
    }
    let data = []
    data = data.map(p => {
      return +p
    })
    console.log("11",this.userData)
    this.$axiox.post('/api/Article/UpadteArticleCreatuser?empolyeeId=' + this.userData.userId +'&empolyeename=' + this.userData.userName +'&articleID=' + this.ArticleID).then(msg => {
      this.$commonJs.alertTips({
        type: 'success',
        title: '成功',
        content: '修改成功',
        stayTime: 5
      })
      this.getList(this.page)
      this.ArticleID = '';
      this.ArticleName = '';
      this.sechUser = ''
      this.userData = {
        userName: '',
        userId: '',
        email: ''
      }
      this.dominUserModel = false
    })
    },
    canceluserModel () {
      this.ArticleID = ''
      this.ArticleName = ''
      this.sechUser = ''
      this.userData = {
        userName: '',
        userId: '',
        email: ''
      }
      this.dominUserModel = false
    },
    searchUser () {
      clearTimeout(allTimeOut)
      allTimeOut = setTimeout(p => {
        if (this.sechUser !== '') {
          this.userData = {
            userName: '',
            userId: '',
            email: ''
          }
          this.getAllUserList(this.sechUser)
          this.isUser = true
        } else {
          this.sechUser = ''
          this.userData = {
            userName: '',
            userId: '',
            email: ''
          }
          this.isUser = false
        }
      }, 1000)
    },
    onSerUser (item) {
      console.log(item)
      this.sechUser = item.chineseName
      this.userData = {
        userName: item.chineseName,
        userId: item.employeeId,
        email: item.email
      }
      this.isUser = false
    },
    getAllUserList (name) {
      let data = {
        pageIndex: 1,
        pageSize: 10,
        keywords: name
      }
      this.$axiox.post('/api/employee/GetAllEmployees', data).then(msg => {
        this.myUserList = msg
      })
    },
    EditCreateuser (item) 
    {
      this.CreateUse = item.createName
      this.ArticleID = item.id
      this.ArticleName = item.id + '-' + item.title
      this.dominUserModel = true
    }
  },
  components: {
    'contentPreview': contentPreview
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/contenListAll.vue